module.exports = __webpack_public_path__ + "static/media/loading.39e7590e.svg";